export enum SalesforceApiDataType {
  // API Primitive Types (non-Apex)
  base64 = "base64",
  boolean = "boolean",
  byte = "byte",
  date = "date",
  datetime = "datetime",
  double = "double",
  int = "int",
  string = "string",
  time = "time",
  id = "id",


  // API Field Types
  address = "address",
  anyType = "anyType",
  calculated = "calculated",
  comboBox = "combobox",
  currency = "currency",
  dataCategoryGroupReference = "DataCategoryGroupReference",
  email = "email",
  encryptedstring = "encryptedstring",
  junctionIdList = "JunctionIdList",
  location = "location",
  masterrecord = "masterrecord",
  multipicklist = "multipicklist",
  percent = "percent",
  phone = "phone",
  picklist = "picklist",
  reference = "reference",
  textarea = "textarea",
  url = "url",
}